import React from "react";
import { Table } from "react-bootstrap";

class InstallationsHourlyTable extends React.Component {
    constructor(props) {
        super(props);
    }

    render() {
        return (
            <div>
                <Table bordered responsive>
                    <thead>
                        <tr>
                            <th>Hour</th>
                            <th>Installs</th>
                            <th>Payouts</th>
                            <th>Revenues</th>
                            <th>onwRevenues</th>
                            <th>Total Revenues</th>
                            <th>ROI</th>
                            <th>ROI %</th>
                        </tr>
                    </thead>

                    <tbody>
                    {
                        this.props.data.map(({ payouts, installs, revenue, onwRevenue, totalRevenue, roi, percentRoi, hour }) => {
                            return (
                                <tr>
                                    <td>{hour}</td>
                                    <td>{installs}</td>
                                    <td>{payouts}</td>
                                    <td>{revenue}</td>
                                    <td>{onwRevenue}</td>
                                    <td>{totalRevenue}</td>
                                    <td>{roi}</td>
                                    <td>{percentRoi}</td>
                                </tr>
                            )
                        })
                    }
                    </tbody>
                </Table>
            </div>
        );
    }
}

export default InstallationsHourlyTable;


// WEBPACK FOOTER //
// ./src/scenes/ApkInstallationsHourly/components/InstallationsHourlyTable/index.js